import { render, staticRenderFns } from "./PostAdmin.vue?vue&type=template&id=c1bb5ec2&scoped=true"
import script from "./PostAdmin.vue?vue&type=script&lang=js"
export * from "./PostAdmin.vue?vue&type=script&lang=js"
import style0 from "./PostAdmin.vue?vue&type=style&index=0&id=c1bb5ec2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1bb5ec2",
  null
  
)

export default component.exports